exports = module.exports = require("../../../../../node_modules/_css-loader@0.23.1@css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".engine-widgets{z-index:20}.engine-widgets,.engine-widgets .engine-widget{overflow:visible;width:0;height:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/_css-loader@0.23.1@css-loader!./~/_less-loader@2.2.3@less-loader!./lib/engine/ui/panes/workspacepane/widgets.less
// module id = 264
// module chunks = 0